import CryptoJS from 'crypto-js';
import Utility from '../../services/utility.service';
import Loader from './../../../shared/components/loader'
import iptracker from '../../../../views/components/commonfunction/iptracker';

export default {
    name: 'pendingAWBVerification',
    components: {
      Utility,
      iptracker,
      Loader
    },
    data: function() {
        return {
            awb:'',
            isLoading: false,
            showAppointmentDate:false,
            userdetail:{},
          }
    },
    mounted() {
        var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.userName = userdetail.email;
        this.userdetail = userdetail;
      },
      methods: {
        isIntegerOnly: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode < 48 || charCode > 57) {
              evt.preventDefault();;
            } else {
              return true;
            }
          },
        async AWBVerification(){
            this.isLoading = true 
            let input = {
                "awb":this.awb.trim()
            }
            let result = await Utility.pendingAWBVerification(input)
            if(result.data.code == 200 ){
                this.$alert(result.data.message, "", "success");
                this.getTraceIP(input);
            }
            else{
                this.$alert(result.data.message, "", "error");
            }
            this.isLoading = false
        },
      
        reset(){
            this.isLoading = false;
            this.awb = '';
        },
        validateAWB() {
            this.$validator.validateAll().then((result) => {
              if (result) {
                this.AWBVerification();
              }
            }).catch(() => {
              console.log('errors exist', this.errors)
            });
          },
          getTraceIP(data) {
            let payload = 
              {
                "projectname": this.userdetail.project,
                "type": "web",
                "userid": this.userdetail.userid,
                "username": this.userdetail.username,
                "routeurl":'/pendingawbverification',
                "meta" : {
                  "event" : `Pending AWB Verification`,
                  "data" : data
                }
            }
            let result = iptracker.getTraceIP(payload);
          },
      }
}


// WEBPACK FOOTER //
// ./src/modules/utility/views/pendingawbverification/pendingawbverification.component.js